import { SupportHubSource } from "@b2bportal/core-self-serve";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./CancellationError.module.scss";
import { ContactSupportModal } from "@/components";

const ComponentName = "CancellationError";

export const CancellationError = ({
  onRetry,
  className,
}: {
  onRetry: (() => Promise<void>) | (() => void);
  className?: string;
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, ComponentName);

  return (
    <div className={clsx(block, className)}>
      <h2 className={cn("title")}>{t("selfServe.cancelErrorTitle")}</h2>
      <p className={cn("cancel-deadline")}>
        {t("selfServe.cancelErrorSubtitle")}
      </p>
      <div className={cn("error-actions")}>
        <ContactSupportModal
          className={cn("error-contact")}
          source={SupportHubSource.cancellation_error}
        />
        <button className={cn("error-retry")} onClick={onRetry} type="button">
          {t("checkoutError.tryAgain")}
        </button>
      </div>
    </div>
  );
};
